export default '/build/78344fd7.jpg'